// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#job-management #header-job-management-toggle {
  height: 50px;
  padding-top: 0;
  padding-bottom: 0;
  position: relative;
}

#job-management .dropdown-jobs {
  max-height: 580px;
  overflow-y: auto;
}

#job-management .three-cogs {
  width: 20px;
  position: relative;
  transform: scale3d(.5, .5, 1)translate(-15px, 20px);
}

#job-management .three-cogs > .fa:first-child {
  animation-duration: 4s;
}

#job-management .three-cogs > .fa:nth-child(2), #job-management .three-cogs > .fa:nth-child(3) {
  animation-duration: 2s;
  animation-direction: reverse;
  position: absolute;
  top: -.2em;
  right: -1.75em;
}

#job-management .three-cogs > .fa:nth-child(3) {
  top: auto;
  bottom: -.2em;
}

#job-management .job-management__message {
  flex-basis: 100%;
}

.job-management__name-detail {
  display: flex;
}

.job-management__content-detail {
  flex-wrap: wrap;
}

.job-management__created-at {
  flex-basis: 100%;
}

@keyframes ipf-job-management-zoomIn {
  from {
    opacity: 0;
    transform: scale3d(.1, .1, 0);
  }

  100% {
    opacity: 1;
  }
}

.ipf-job-management-zoomIn {
  transform-origin: 41px 12px;
  animation-name: ipf-job-management-zoomIn !important;
  animation-duration: .5s !important;
  animation-fill-mode: forwards !important;
}

@keyframes ipf-job-management-zoomOut {
  from {
    opacity: 1;
  }

  100% {
    opacity: 0;
    transform: scale3d(.1, .1, 0);
  }
}

.ipf-job-management-zoomOut {
  transform-origin: 41px 12px;
  animation-name: ipf-job-management-zoomOut !important;
  animation-duration: .5s !important;
  animation-fill-mode: forwards !important;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/containers/App/Header/JobManagement/styles/JobManagement.css","webpack://./services/frontend/app/containers/App/Header/JobManagement/styles/JobManagement.css"],"names":[],"mappings":"AADA;ECEE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,2BAA2B;EAC3B,oDAAoD;EACpD,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,6BAA6B;EAC/B;AACF;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;EACrD,kCAAkC;EAClC,wCAAwC;AAC1C","sourcesContent":["#job-management #header-job-management-toggle {\n    position: relative;\n    height: 50px;\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n  #job-management .dropdown-jobs {\n    max-height: 580px;\n    overflow-y: auto;\n  }\n  #job-management .three-cogs {\n    width: 20px;\n    position: relative;\n    transform: scale3d(0.5, 0.5, 1) translate(-15px, 20px);\n  }\n  #job-management .three-cogs > .fa:nth-child(1) {\n      animation-duration: 4s;\n    }\n  #job-management .three-cogs > .fa:nth-child(2),\n    #job-management .three-cogs > .fa:nth-child(3) {\n      position: absolute;\n      top: -0.2em;\n      right: -1.75em;\n      animation-direction: reverse;\n      animation-duration: 2s;\n    }\n  #job-management .three-cogs > .fa:nth-child(3) {\n      top: auto;\n      bottom: -0.2em;\n    }\n  #job-management .job-management__message {\n    flex-basis: 100%;\n  }\n\n.job-management__name-detail {\n    display: flex;\n}\n\n.job-management__content-detail {\n    flex-wrap: wrap;\n}\n\n.job-management__created-at {\n  flex-basis: 100%;\n}\n\n@keyframes ipf-job-management-zoomIn {\n  from {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0);\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n.ipf-job-management-zoomIn {\n  animation-duration: 0.5s !important;\n  transform-origin: 41px 12px;\n  animation-name: ipf-job-management-zoomIn !important;\n  animation-fill-mode: forwards !important;\n}\n\n@keyframes ipf-job-management-zoomOut {\n  from {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0);\n  }\n}\n\n.ipf-job-management-zoomOut {\n  animation-duration: 0.5s !important;\n  transform-origin: 41px 12px;\n  animation-name: ipf-job-management-zoomOut !important;\n  animation-fill-mode: forwards !important;\n}\n","#job-management #header-job-management-toggle {\n  height: 50px;\n  padding-top: 0;\n  padding-bottom: 0;\n  position: relative;\n}\n\n#job-management .dropdown-jobs {\n  max-height: 580px;\n  overflow-y: auto;\n}\n\n#job-management .three-cogs {\n  width: 20px;\n  position: relative;\n  transform: scale3d(.5, .5, 1)translate(-15px, 20px);\n}\n\n#job-management .three-cogs > .fa:first-child {\n  animation-duration: 4s;\n}\n\n#job-management .three-cogs > .fa:nth-child(2), #job-management .three-cogs > .fa:nth-child(3) {\n  animation-duration: 2s;\n  animation-direction: reverse;\n  position: absolute;\n  top: -.2em;\n  right: -1.75em;\n}\n\n#job-management .three-cogs > .fa:nth-child(3) {\n  top: auto;\n  bottom: -.2em;\n}\n\n#job-management .job-management__message {\n  flex-basis: 100%;\n}\n\n.job-management__name-detail {\n  display: flex;\n}\n\n.job-management__content-detail {\n  flex-wrap: wrap;\n}\n\n.job-management__created-at {\n  flex-basis: 100%;\n}\n\n@keyframes ipf-job-management-zoomIn {\n  from {\n    opacity: 0;\n    transform: scale3d(.1, .1, 0);\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n.ipf-job-management-zoomIn {\n  transform-origin: 41px 12px;\n  animation-name: ipf-job-management-zoomIn !important;\n  animation-duration: .5s !important;\n  animation-fill-mode: forwards !important;\n}\n\n@keyframes ipf-job-management-zoomOut {\n  from {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n    transform: scale3d(.1, .1, 0);\n  }\n}\n\n.ipf-job-management-zoomOut {\n  transform-origin: 41px 12px;\n  animation-name: ipf-job-management-zoomOut !important;\n  animation-duration: .5s !important;\n  animation-fill-mode: forwards !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
